import React, { useEffect, useState } from 'react';

import ErrorBoundary from './ErrorBoundary';
import Routes from './routes';

import GlobalAlert from './next/components/global/alert';
import GlobalLoader from './next/components/global/Loader';

import { isMobile } from './utils/mobile';

export default function App() {
  useEffect(() => {
    if (process.env.REACT_APP_ENV.toLowerCase() !== 'production') {
      document.head.getElementsByTagName('title')[0].innerHTML += ' ** ДЕМО РЕЖИМ ** ';
    }
  }, []);

  const [isMobileView, setIsMobileView] = useState(isMobile());
    
    useEffect(() => {
      const handleResize = () => {
        setIsMobileView(isMobile());
      };
  
      window.addEventListener('resize', handleResize);
      window.focus();
      document.body.focus();

      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
  if(isMobileView) {
    return (
      <div className={'mobile'}>
        <ErrorBoundary>
          <Routes />

          <GlobalAlert />
          <GlobalLoader />
        </ErrorBoundary>
      </div>
    );
  }

  return (
      <ErrorBoundary>
        <Routes />

        <GlobalAlert />
        <GlobalLoader />
      </ErrorBoundary>
  );
}
